import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormModel} from '../../../../common/components/form/models';

@Component({
  selector: 'app-rendu-formulaire-container',
  templateUrl: './modale-rendu-formulaire.component.html',
  styleUrls: ['./modale-rendu-formulaire.component.scss']
})
export class ModaleRenduFormulaireComponent implements OnInit {
  formModel: FormModel;
  constructor(public dialogRef: MatDialogRef<ModaleRenduFormulaireComponent>,
              @Inject(MAT_DIALOG_DATA) public data: FormModel) {
    this.formModel = data;
  }
  ngOnInit(): void {
  }
}
